import { useEffect, useState } from 'react';
import AdminCard from '../../../components/admin/AdminCard';
import InvestorProjectResumeConfigForm from './InvestorProjectResumeConfigForm';
import {
  IBaseProjectResumeConfig,
  IResumeProjectConfig,
} from '../models/projectResumeConfigModel';
import useAdminPropetyLayoutConfig from '../hooks/useAdminProjectLayoutConfig';
import { useNavigate } from 'react-router-dom';

interface Props {
  projectId: string;
  handleProjectResumeId: (id: string) => void;
}

const InvestorProjectResumeConfigCard = ({
  projectId,
  handleProjectResumeId,
}: Props) => {
  const {
    apiErrors,
    doCreateProjectResumeConfig,
    doRetrieveInitialConfigResume,
    doRetrieveResumeConfigByProject,
    doUpdateProjectResumeConfig,
  } = useAdminPropetyLayoutConfig();

  const navigate = useNavigate();

  const [projectResume, setProjectResume] = useState<IResumeProjectConfig>({
    id: '',
    resume_area: '',
    resume_bathrooms: '',
    resume_bedrooms: '',
    resume_description: '',
    resume_parking: '',
    resume_square_rods: '',
  });

  const [isUpdate, setIsUpdate] = useState<boolean>(false);

  //handle

  const handleForm = async (form: IBaseProjectResumeConfig) => {
    if (isUpdate) {
      const result = await doUpdateProjectResumeConfig(projectResume.id, form);
      if (result === 200) navigate(0);
    } else {
      const result = await doCreateProjectResumeConfig(projectId, form);
      if (result === 201) navigate(0);
    }
  };

  //load here

  const loadResumePerProject = async () => {
    const resume = await doRetrieveResumeConfigByProject(projectId);

    if (resume) {
      setProjectResume(resume);
      setIsUpdate(true);
      handleProjectResumeId(resume.id);
    } else {
      const initialState = await doRetrieveInitialConfigResume(projectId);
      setProjectResume({
        id: '',
        ...initialState,
      });
    }
  };

  useEffect(() => {
    //call first
    loadResumePerProject().then().catch();
  }, [projectId]);

  return (
    <AdminCard
      children={
        <InvestorProjectResumeConfigForm
          handleForm={handleForm}
          projectId={projectId}
          projectResumeConfig={projectResume}
          isUpdate={isUpdate}
        />
      }
      title="Resume de proyecto"
    />
  );
};

export default InvestorProjectResumeConfigCard;
